import React from "react";
import { Button } from "antd";
import styles from "./ActionGroup.module.css";

const ANT_TYPE = {
  primary: "primary",
  secondary: "default",
  ghost: "default",
  outline: "default",
  danger: "default",
  text: "text",
};

const ActionGroup = ({ actions = [], align = "center" }) => (
  <div className={styles.group} data-align={align}>
    {actions.map((action) => {
      if (action.condition === false) return null;

      const antType = ANT_TYPE[action.variant] || "primary";
      const classes = [styles.actionBtn];

      if (action.variant === "secondary") classes.push(styles.secondary);
      if (action.variant === "amber") classes.push(styles.amber);

      return (
        <Button
          key={action.key || action.label}
          type={antType}
          className={classes.join(" ")}
          onClick={action.onClick}
          disabled={action.disabled}
          icon={action.icon}
        >
          {action.label}
        </Button>
      );
    })}
  </div>
);

export default ActionGroup;
